import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=76a411cc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a411cc')) {
      api.createRecord('76a411cc', component.options)
    } else {
      api.reload('76a411cc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=76a411cc&", function () {
      api.rerender('76a411cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/pricehelp.vue"
export default component.exports